export default function AddEditFolderDialogController(
  ssDialogService,
  loaderService,
  alerts,
  confirmDialog,
  documentAssociationDialog,
  docDataService
) {
  const vm = this;

  vm.handleSaveDialogClick = _handleSaveDialogClick;
  vm.handleCloseDialogClick = _handleCloseDialogClick;
  // vm.handleFolderServiceVisiblityChange = _handleFolderServiceVisiblityChange;
  vm.handleYesDeleteFolderDialogClick = _handleYesDeleteFolderDialogClick;
  vm.handleCloseDeleteFolderDialogClick = _handleCloseDeleteFolderDialogClick;
  vm.handleSomeSelectedCheck = _handleSomeSelectedCheck;

  vm.customerId = vm.customerId || 0;
  vm.folderList = vm.folderList || [];
  vm.folderId = vm.folderId || -1;
  vm.serviceId = vm.serviceId || null;
  vm.parentFolderId = vm.parentFolderId || null;
  vm.folderName = vm.folderName || null;
  vm.folder = vm.folder || null;
  vm.selectedServices = {};
  // {
  //  folderId: vm.folderId,
  //  parentFolderId: vm.parentFolderId,
  //  folderName: vm.folderName,
  // };
  vm.parentFolder = vm.parentFolder || null;
  vm.applyToChildren = 0;
  vm.documentAssociations = [];
  vm.serviceChanged = null;

  _activate();

  function _activate() {
    angular.forEach(vm.folderList, (folder) => {
      folder.isExpanded = false;
    });

    angular.forEach(vm.folder.customerServices, (custService) => {
      angular.forEach(vm.folder.folderVisibilities, (folderVisibility) => {
        if (custService.serviceId === folderVisibility.serviceId) {
          vm.selectedServices[custService.serviceId] = true;
        }
      });
    });
    // loaderService.showViewLoader = true;
    //
    // const dfdAssoc = docDataService.getDocumentAssociationsByFolder(vm.folderId, null);
    // dfdAssoc.then((isSuccess) => {
    //   if ((isSuccess.statusText === 'OK') || (isSuccess.statusText === '')) {
    //     vm.documentAssociations = isSuccess.data;
    //   }
    // }).finally(() => {
    //   loaderService.showViewLoader = false;
    // });
  }

  function _handleSomeSelectedCheck(object) {
    return Object.keys(object).some(key => object[key]);
  }

  function _handleSaveDialogClick(form) {
    if (form.$valid) {
      loaderService.showViewLoader = true;
      docDataService.folderExists(vm.customerId, vm.parentFolderId, vm.folderId, vm.folderName)
        .then((response) => {
          if (!response.data.result) {
            // Save Folder
            const isNew = vm.folderId <= 0;
            const applyToChildren = (vm.applyToChildren === '1');

            vm.folder.assignments = '';
            angular.forEach(vm.folder.customerServices, (customerService) => {
              if (vm.selectedServices[customerService.serviceId]) {
                if (vm.folder.assignments === '') {
                  vm.folder.assignments = customerService.serviceId;
                } else {
                  vm.folder.assignments = `${vm.folder.assignments},${customerService.serviceId}`;
                }
              }
            });

            docDataService.saveFolder(
              vm.customerId,
              vm.serviceId,
              vm.parentFolderId,
              vm.folderId,
              vm.folderName,
              vm.folder.assignments,
              applyToChildren
            ).then((res) => {
              if (!!res.data && res.data.folderId > 0) {
                if (isNew) {
                  vm.folder.parentFolderId = vm.parentFolderId;
                  vm.folder.folderId = res.data.folderId;
                  vm.folder.deletable = true;
                  vm.folder.parentFolder = vm.parentFolder;
                  vm.folder.childrenCount = 0;
                  vm.folder.maxSubFolderNameLength = res.data.maxSubFolderNameLength;
                }

                docDataService.getFolderVisiblities(res.data.folderId)
                  .then((getResult) => {
                    vm.folder.folderVisibilities = getResult.data.result;

                    if (vm.folder) {
                      vm.folder.folderName = vm.folderName;
                    }

                    if (vm.updateCallback) {
                      vm.updateCallback(vm.parentFolder, vm.folder);
                    }

                    alerts.success(`Folder ${vm.folderName} has been saved successfully.`);

                    ssDialogService.hide(ssDialogService.dialogs.global.addEditFolderDialog);
                  });
              } else {
                alerts.error(`Error occurred while saving folder ${vm.folderName}.`);
              }
            });
          } else {
            // Message when folder exists
            alerts.error(`${vm.folderName} folder already exists.`);
          }
          loaderService.showViewLoader = false;
        });
    }
  }

  function _handleCloseDialogClick() {
    ssDialogService.hide(ssDialogService.dialogs.global.addEditFolderDialog);
  }

  function _handleYesDeleteFolderDialogClick() {
    vm.serviceChanged.isSelected = false;
    ssDialogService.hide(ssDialogService.dialogs.global.documentAssociationDialog);
    return ssDialogService.hide(ssDialogService.dialogs.global.documentManagementDeleteDocumentDialog);
  }

  function _handleCloseDeleteFolderDialogClick() {
    vm.serviceChanged.isSelected = true;
    return ssDialogService.hide(ssDialogService.dialogs.global.documentManagementDeleteDocumentDialog);
  }

  // function _handleAcceptDocumentAssociationDelete() {
  //   vm.serviceChanged.isSelected = false;
  //   return ssDialogService.hide(ssDialogService.dialogs.global.documentAssociationDialog);
  //
  //   // ssDialogService.dialogs.global.documentManagementDeleteDocumentDialog = ssDialogService.alert(
  //   //   confirmDialog.getOptions($event, {
  //   //     dialogTitle: 'Remove Association?',
  //   //     message: `Are you sure you want to remove the associations for ${vm.folderName} folder?`,
  //   //     handleYesClick: vm.handleYesDeleteFolderDialogClick,
  //   //     handleNoClick: vm.handleCloseDeleteFolderDialogClick,
  //   //     referenceObject: {
  //   //       parentFolder,
  //   //       folder,
  //   //       service
  //   //     },
  //   //   }),
  //   // );
  //   //
  //   // ssDialogService.show(ssDialogService.dialogs.global.documentManagementDeleteDocumentDialog);
  // }

  // function _handleDeclineDocumentAssociationDelete() {
  //   vm.serviceChanged.isSelected = true;
  // }

  // function _handleFolderServiceVisiblityChange($event, serviceChanged) {
  //   if (serviceChanged.isSelected === false) {
  //     vm.serviceChanged = serviceChanged;
  //     const assocs = R.filter(d => d.serviceId === serviceChanged.serviceId, vm.documentAssociations);
  //
  //     if (assocs.length > 0) {
  //       _showDocumentAssociationsDialog($event, {
  //         folderId: vm.folderId,
  //         documentId: null,
  //         serviceId: serviceChanged.serviceId,
  //         service: serviceChanged,
  //         associations: assocs,
  //         document: null,
  //         folder: vm.folder,
  //         acceptCallback: _handleAcceptDocumentAssociationDelete,
  //         declineCallback: _handleDeclineDocumentAssociationDelete
  //       });
  //     }
  //   }
  // }

  // function _showDocumentAssociationsDialog($event, locals) {
  //   ssDialogService.dialogs.global.documentAssociationDialog = ssDialogService.alert(
  //     documentAssociationDialog.getOptions($event, locals)
  //   );
  //   return ssDialogService.show(ssDialogService.dialogs.global.documentAssociationDialog);
  // }
}


AddEditFolderDialogController.$inject = [
  'ssDialogService',
  'loaderService',
  'alerts',
  'confirmDialog',
  'documentAssociationDialog',
  'docDataService'
];
